import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="harmful-object-route"
        path="/harmful-object/:id?"
        component={Page} />
];

export default Routes;